import { io } from "socket.io-client";

let socket = null;

export function connectAndGetSocket() {
  if (!socket) {
    socket = io(process.env.REACT_APP_API_BASE_URL || "http://localhost:3000", {
      path:"/api/socket",
      withCredentials: true,
    });    
    console.log(socket.io.opts);
    socket.on("connect", () => {
      console.log("✅ Socket Connected");
    });

    socket.on("connect_error", (err) => {
      console.log("❌ Socket Connect error:", err.message);
      console.log(err);
    });

    socket.on("disconnect", (reason) => {
      console.log("Socket Disconnected:", reason);
    });
  }
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
